<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b>{{title}}</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <form *ngIf="form" role="form" [formGroup]="form" name="addEditForm" novalidate>
    <div *ngIf="showSelectResourceMessage" class="alert alert-warning" role="alert">
      <span>Please select a {{user.resourceSettings?.label || 'resource' }} to track it on the served page.</span>
    </div>
    <div class="row">
      <!-- Phone -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-phone" class="control-label">Phone<br></label>
        <div class="d-flex">
          <input
            id="input-modal-phone"
            type="tel"
            pattern="[\-+\(\)\s\d]*"
            formControlName="phone"
            data-dd-privacy="mask"
            [ngClass]="{'is-invalid': form.get('phone').touched && form.get('phone').invalid }"
            class="form-control"
            trTrimSpaces
            [class.mr-2]="isWhatsAppEnabled()"
          >
          <tablesready-whatsapp-toggle
            *ngIf="isWhatsAppEnabled()"
            formControlName="messagingProvider"
            ngbTooltip="Send via WhatsApp"
          ></tablesready-whatsapp-toggle>
        </div>
        <control-messages [control]="form.get('phone')"></control-messages>

      </div>
      <!-- Name -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-name" class="control-label">Name</label>
        <input
          id="input-modal-name"
          type="text"
          formControlName="name"
          name="name"
          data-dd-privacy="mask"
          noWhitespace
          [ngClass]="{'is-invalid': form.get('name').touched && form.get('name').invalid }"
          class="form-control"
          trTrimSpaces
        />
        <control-messages [control]="form.get('name')"></control-messages>
      </div>
    </div>

    <div class="row" *ngIf="customer">
      <div class="col-12 form-group">
        <tablesready-party-customer-info
          [customer]="customer"
          [timezone]="timezone"
        ></tablesready-party-customer-info>
      </div>
    </div>

    <div class="row">
      <!-- Size -->
      <div class="col-xs-12 col-sm-6 form-group" *ngIf="user.waitFields.size">
        <label for="input-modal-size" class="control-label">Size</label>
        <div class="btn-group d-flex flex-wrap" id="input-modal-size">
          <frontend-size-input
            [formControl]="requestGroup.get('size')"
            [defaultValue]="user.default_size"
          ></frontend-size-input>
        </div>
      </div>

      <!-- Notes -->
      <div class="form-group" [ngClass]="user.waitFields.size ? ['col-xs-12', 'col-sm-6'] : 'col-12'">
        <ng-container *ngIf="noteOptions?.length > 0; else plainNoteInput">
          <frontend-dropdown-clear [dropdown]="notesDropdown">
            <label for="input-modal-note" class="control-label">Notes</label>
          </frontend-dropdown-clear>
          <frontend-dropdown
            #notesDropdown
            elementId="input-modal-note"
            formControlName="note"
            placeholder="Select notes"
            clearAllText="Clear"
            [plainValues]="true"
            [items]="noteOptions"
            [multiple]="true"
            [addTag]="true"
            [clearable]="true"
            [inlineClearButton]="false"
          ></frontend-dropdown>
        </ng-container>
        <ng-template #plainNoteInput>
          <label for="input-modal-note" class="control-label">Notes</label>
          <input
            id="input-modal-note"
            type="text"
            class="form-control"
            formControlName="note"
            trTrimSpaces
          />
        </ng-template>
      </div>
    </div>

    <div class="row" formGroupName="requestGroup">
      <!-- Date -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="reservation-date-input" class="control-label">Date</label>
        <input
          id="reservation-date-input"
          class="form-control"
          type="text"
          formControlName="date"
          ngbDatepicker
          [minDate]="minDate"
          [weekdays]="true"
          [firstDayOfWeek]="7"
          #datepicker="ngbDatepicker"
          name="date"
          [ngClass]="{'is-invalid': getGroupField('date').touched && getGroupField('date').invalid}"
          (click)="datepicker.toggle()"
          [restoreFocus]="true"
          autocomplete="off"
        />
        <div *ngIf="!getGroupField('date').value">
          <div class="error-messages">This field is required</div>
        </div>
      </div>
      <!-- Time -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">Time</label>
        <tr-timepicker-input
          formControlName="time"
          [ngClass]="{'is-invalid': (getGroupField('time').dirty || getGroupField('time').touched) && !getGroupField('time').value }"
        ></tr-timepicker-input>
        <control-messages [control]="getGroupField('time')"></control-messages>
      </div>
    </div>

    <div class="row">
      <!-- services -->
      <ng-container formGroupName="requestGroup">
        <div *ngIf="servicesInDropdown?.length" class="col-xs-12 col-sm-6 form-group">
          <frontend-dropdown-clear [dropdown]="servicesDropdown">
            <label class="control-label">
              {{serviceSettingsLabel}}
              <span *ngIf="shortenedDurationState?.hasShortenedDuration" class="text-warning ml-1">⚠️</span>
            </label>
          </frontend-dropdown-clear>

          <frontend-dropdown
            #servicesDropdown
            elementId="input-modal-service"
            formControlName="services"
            clearAllText="Clear"
            [items]="servicesInDropdown"
            [multiple]="true"
            [clearable]="true"
            [inlineClearButton]="false"
            [customOptionHtml]="getServiceOptionName"
          ></frontend-dropdown>
        </div>
        <!-- duration -->
        <div *ngIf="servicesInDropdown?.length && getGroupField('services')?.value?.length && getGroupField('duration')?.value" class="col-xs-12 col-sm-6 form-group">
          <label for="input-modal-services-duration" class="control-label">{{serviceSettingsLabel}} duration</label>
          <tablesready-duration
            id="input-modal-services-duration"
            formControlName="duration"
          ></tablesready-duration>
        </div>
        <!-- resources -->
        <div *ngIf="resourcesInDropdown?.length" class="col-xs-12 col-sm-6 form-group">
          <frontend-dropdown-clear [dropdown]="resourcesDropdown">
            <label class="control-label">{{resourceSettingsLabel}}</label>
          </frontend-dropdown-clear>

          <frontend-dropdown
            #resourcesDropdown
            elementId="input-modal-resource"
            formControlName="resources"
            bindLabel="name"
            bindValue="_id"
            clearAllText="Clear"
            [items]="resourcesInDropdown"
            [multiple]="true"
            [customName]="getItemName"
            [customOptionHtml]="getItemOptionName"
            [clearable]="true"
            [inlineClearButton]="false"
            [markFirstSuggested]="user?.resourceSettings.resourceSuggestion === resourceSuggestionOption.suggestion"
          ></frontend-dropdown>
        </div>
      </ng-container>
    </div>

    <tablesready-party-custom-fields
      *ngIf="availableOnBusinessPlan"
      id="customFields"
      name="customFields"
      formControlName="customFields"
      [config]="user.partyFields"
      [country]="user.country"
    ></tablesready-party-custom-fields>

    <ng-container formGroupName="requestGroup">
      <div *ngIf="isAvailableTime && !isSubmitting" class="alert alert-warning d-flex justify-content-between" role="alert">
        Sorry, we don't have an available {{resourceSettingsLabel}} at
        this time.
        <label class="form-check-label pl-0 d-flex">
          <strong>Override?</strong>
          <input
            type="checkbox"
            class="ml-2"
            name="overrideNoResources"
            formControlName="overrideNoResources"
          >
        </label>
      </div>
      <div *ngIf="checkIfOutOfBusinessHours()" class="alert alert-warning" role="alert">
        {{ getOutOfBusinessHoursMessage() }}
        <label class="form-check-label pl-0 d-flex">
          <strong>Override?</strong>
          <input
            type="checkbox"
            class="ml-2"
            name="overrideIsWorkTime"
            formControlName="overrideIsWorkTime"
          >
        </label>
      </div>
      <div *ngIf="blockedTime?.blocked && !overrideBlockedTime" class="alert alert-warning d-flex justify-content-between" role="alert">
        This time is blocked for new {{ displayOptionsReservationsLabelPlural }}.
        <label class="form-check-label pl-0 d-flex">
          <strong>Override?</strong>
          <input
            type="checkbox"
            class="ml-2"
            name="overrideBlockedTime"
            formControlName="overrideBlockedTime"
          >
        </label>
      </div>
    </ng-container>
    <div *ngIf="noAvailableServices && !isSubmitting" class="alert alert-warning" role="alert">
      Sorry, no services available at this time.
    </div>
    <div *ngIf="resourceSizeAlert && !isSubmitting" class="alert alert-warning" role="alert">
      {{ resourceSizeAlert }}
    </div>
    <div *ngIf="showOverlappingAlert && !overrideNoResources && !isSubmitting" class="alert alert-warning" role="alert">
      Sorry, this {{displayOptionsReservationsLabel}} overlaps
      with another.
      Available duration is {{availablePartyDurationInMin}} min
      <div class="link" (click)="setAvailableDuration()">Set duration to available time?</div>
    </div>
    <!-- Shortened duration warning -->
    <tablesready-shortened-duration-warning
      *ngIf="!isSubmitting"
      [state]="shortenedDurationState"
      [(confirmed)]="shortenedDurationConfirmed"
    ></tablesready-shortened-duration-warning>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button
    *ngIf="partyToEdit?.checkin_time && !partyToEdit?.seated_time"
    type="button"
    class="btn btn-success mr-auto"
    (click)="undoCheckIn()"
    angularticsCategory="reservations"
    angulartics2On="click"
    angularticsAction="undo reservation check-in"
    [disabled]="isSubmitting"
  >Undo Check-In</button>
  <button
    *ngIf="partyToEdit?.checkin_time && partyToEdit?.seated_time"
    type="button"
    class="btn btn-success mr-auto"
    (click)="undoServed()"
    angularticsCategory="parties"
    angulartics2On="click"
    angularticsAction="undo party serve"
    [disabled]="isSubmitting"
  >Undo Served</button>
  <button
    type="submit"
    class="btn btn-info"
    (click)="ok()"
    angularticsCategory="reservations"
    angulartics2On="click"
    id="confirm-add-edit-party-button"
    [disabled]="submitDisabled"
    angularticsAction="{{angularticsActionType}}"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
  >Cancel</button>
</div>

<ng-template #confirmModalContent let-confirmModal>
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title">
      There is already a {{displayOptionCustomerLabel}} on your waitlist with this phone number. Are you sure you want to proceed?
    </h3>
    <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="confirmModal.close('Cancel click')"></tr-icon>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-info"
            (click)="confirmModal.close('Confirm click')">Confirm
    </button>
    <button type="button" class="btn btn-danger"
            (click)="confirmModal.close('Cancel click')">Cancel
    </button>
  </div>
</ng-template>
